<template>
  <svg width="20"
       height="17"
       viewBox="0 0 20 17"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M3.0127 16.3887H17.1895C18.8857 16.3887 19.8701 15.4043 19.8701 13.5234V3.81152C19.8701 1.93066 18.877 0.946289 16.9785 0.946289H2.80176C1.10547 0.946289 0.121094 1.92188 0.121094 3.81152V13.5234C0.121094 15.4043 1.11426 16.3887 3.0127 16.3887ZM9.00684 8.9707L2.6084 2.64258C2.73145 2.61621 2.87207 2.59863 3.02148 2.59863H16.9697C17.1279 2.59863 17.2686 2.61621 17.4004 2.65137L11.0107 8.9707C10.6416 9.33105 10.334 9.48926 10.0088 9.48926C9.68359 9.48926 9.37598 9.32227 9.00684 8.9707ZM1.76465 3.93457L6.5459 8.63672L1.76465 13.3652V3.93457ZM13.4717 8.63672L18.2266 3.96094V13.3477L13.4717 8.63672ZM3.02148 14.7275C2.86328 14.7275 2.71387 14.71 2.58203 14.6836L7.61816 9.69141L8.09277 10.166C8.73438 10.79 9.34961 11.0537 10.0088 11.0537C10.6592 11.0537 11.2832 10.79 11.916 10.166L12.3994 9.69141L17.4268 14.6748C17.2861 14.71 17.1367 14.7275 16.9697 14.7275H3.02148Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'EmailIcon',
  props: {
    width: {
      type: Number,
      default: 256
    },
    height: {
      type: Number,
      default: 256
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
